import { OrganizationInsuranceService } from '@aid/administration/services/organization-insurance.service';

export const services = [OrganizationInsuranceService];

export * from './insurance-type.service';
export * from './providers.service';
export * from './organization-provider.service';
export * from './organization-insurance.service';
